import React, {useState} from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';

export const ChironSwitch = withStyles({
    switchBase: {
        color: '#173763',
        '&$track':{
            backgroundColor: '#6a8ab5'
        },
        '&$checked': {
            color: '#4C8B2B',
        },
        '&$checked + $track': {
            backgroundColor: '#76a25f',
        },
    },
    checked: {},
    track: {
        backgroundColor: '#6a8ab5'},
  })(Switch);

export const ChironSwitchGray = withStyles({
    switchBase: {
        color: '#bdbdbd',
        '&$track':{
            backgroundColor: '#7a7a7a'
        },
        '&$checked': {
            color: '#4C8B2B',
        },
        '&$checked + $track': {
            backgroundColor: '#76a25f',
        },
    },
    checked: {},
    track: {
        backgroundColor: '#6a8ab5'},
  })(Switch);